import { BreadcrumbItem } from '@src/api/common/BreadcrumbTypes';
import { PageTitle } from '@src/api/common/PageTitleType';

const Breadcrumbs: Array<BreadcrumbItem> = [
  {
    title: 'Home',
    href: '/',
  },
  {
    title: 'DataTable Example',
    isLink: false,
  },
];

const Title: PageTitle = {
  title: 'Employee Management',
};

export { Breadcrumbs, Title };
